import { useCallback, useState } from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import ProjectButton from './ProjectButton';
import ProjectContainer from './ProjectContainer';

export default function ProjectDrawer(details) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = useCallback(() => setIsOpen(true), []);

  return (
    <>
      <ProjectButton handleToggle={handleToggle} {...details} />
      <SwipeableDrawer
        anchor="bottom"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        disableSwipeToOpen
        SlideProps={{
          style: {
            borderTopLeftRadius: '0.75rem',
            borderTopRightRadius: '0.75rem',
            width: '100%',
            maxWidth: '700px',
            justifySelf: 'center',
          },
        }}
      >
        <ProjectContainer handleClose={() => setIsOpen(false)} {...details} isOpen={isOpen} />
      </SwipeableDrawer>
    </>
  );
}
